import { useState, useCallback } from 'react';
import toast from 'react-hot-toast';
import { toastDefsError } from '../config/toastConfig';

interface ViaCepResponse {
  cep: string;
  logradouro: string;
  complemento: string;
  bairro: string;
  localidade: string;
  uf: string;
  erro?: boolean;
}

interface UseCepLookupReturn {
  loadingCep: boolean;
  buscarCep: (cep: string, onSuccess?: (data: ViaCepResponse) => void) => Promise<void>;
}

export const useCepLookup = (): UseCepLookupReturn => {
  const [loadingCep, setLoadingCep] = useState(false);

  const buscarCep = useCallback(async (cep: string, onSuccess?: (data: ViaCepResponse) => void) => {
    const cepLimpo = cep.replace(/\D/g, '');
    
    if (cepLimpo.length !== 8) {
      return;
    }

    setLoadingCep(true);

    try {
      const response = await fetch(`https://viacep.com.br/ws/${cepLimpo}/json/`);
      const data: ViaCepResponse = await response.json();

      if (data.erro) {
        toast.error('CEP não encontrado. Verifique o CEP digitado.', toastDefsError);
        return;
      }

      if (onSuccess) {
        onSuccess(data);
      }
    } catch (error) {
      console.error('Erro ao buscar CEP:', error);
      toast.error('Erro ao buscar CEP. Tente novamente.', toastDefsError);
    } finally {
      setLoadingCep(false);
    }
  }, []);

  return {
    loadingCep,
    buscarCep
  };
};

export type { ViaCepResponse };

